import React, { useState, Fragment, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import API from '../../services/API';
import { Tag, Dropdown, Menu } from 'antd';
import Select from "react-select";


const TeacherPage = () => {
  const [teachers, setTeachers] = useState([]);
  const [modalAddTeacher, setModalAddTeacher] = useState(false);
  const [newTeacher, setNewTeacher] = useState({
    name: '',
    username: '',
    tags: [],
    session: 0
  });
  const [modalEditTeacher, setModalEditTeacher] = useState(false);
  const [editTeacher, setEditTeacher] = useState({
    teacher_uuid: '',
    name: '',
    role: '',
    tags: [],
    session: 0
  });
  const [modalDeleteTeacher, setModalDeleteTeacher] = useState(false);
  const [teacherToDelete, setTeacherToDelete] = useState(null);
  const [filterText, setFilterText] = useState("");

  const filteredTeachers = teachers.filter((teacher) => {
    const name = teacher.full_name?.toLowerCase() || "";
    const phone = teacher.phone_no?.toLowerCase() || "";
    const email = teacher.email?.toLowerCase() || "";
    const tags = (teacher.tags || []).join(" ").toLowerCase();

    return (
      name.includes(filterText.toLowerCase()) ||
      phone.includes(filterText.toLowerCase()) ||
      email.includes(filterText.toLowerCase()) ||
      tags.includes(filterText.toLowerCase())
    );
  });

  const openDeleteTeacherModal = (row) => {
    setTeacherToDelete(row);
    setModalDeleteTeacher(true);
  };

  const closeDeleteTeacherModal = () => {
    setTeacherToDelete(null);
    setModalDeleteTeacher(false);
  };

  const openEditTeacherModal = (row) => {
    setEditTeacher({
      teacher_uuid: row.teacher_uuid,
      name: row.full_name,
      role: row.role?.toString() ?? '', // always string for select
      tags: row.tags || [],
      session: row.session?.toString() ?? '',
    });
    setModalEditTeacher(true);
  };

  const closeEditTeacherModal = () => {
    setModalEditTeacher(false);
    setEditTeacher({ teacher_uuid: '', name: '', role: '' });
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditTeacher((prevState) => ({
      ...prevState,
      [name]: name === "name" ? value.toUpperCase() : value,
    }));
  };

  const handleEditTeacher = () => {
    const { teacher_uuid, name, role, tags,session} = editTeacher;
    if (!teacher_uuid || !name || role === '') {
      toast.error('All fields are required', { autoClose: 5000 });
      return;
    }
    var headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: localStorage.getItem('token'),
    };
    API.post('/portal/editTeacher', {
      teacher_uuid,
      name,
      role: parseInt(role),
      session: parseInt(session), 
    }, { headers })
      .then((response) => {
        if (response.data.response_code === 1000) {
          // 2. Update tags
          API.post('/portal/updateTeacherTags', {
            teacher_uuid,
            tags,
          }, { headers })
            .then((res) => {
              if (res.data.response_code === 1000) {
                toast.success('Teacher & Tags updated successfully', { autoClose: 5000 });
                closeEditTeacherModal();
                fetchTeachers();
              } else {
                toast.error(res.data.message, { autoClose: 5000 });
              }
            });
        } else {
          toast.error(response.data.message, { autoClose: 5000 });
        }
      })
      .catch(() => {
        toast.error('Error updating teacher', { autoClose: 5000 });
      });
  };


  const toggleAddTeacherModal = () => setModalAddTeacher(!modalAddTeacher);

  const fetchTeachers = () => {
    var headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: localStorage.getItem('token'),
    };
    API.get('/portal/getTeachers', { headers })
      .then((response) => {
        if (response.data.response_code === 1000) {
          setTeachers(response.data.data);
        } else {
          toast.error(response.data.message, { autoClose: 5000 });
        }
      })
      .catch(() => {
        toast.error('Error fetching teachers', { autoClose: 5000 });
      });
  };

  const handleDeleteTeacher = (username) => {
    var headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: localStorage.getItem('token'),
    };
    API.delete('/portal/deleteTeacher', {
      headers,
      data: { username },
    })
      .then((response) => {
        if (response.data.response_code === 1000) {
          toast.success('Teacher deleted successfully', { autoClose: 5000 });
          fetchTeachers(); // Refresh the teacher list
        } else {
          toast.error(response.data.message, { autoClose: 5000 });
        }
      })
      .catch(() => {
        toast.error('Error deleting teacher', { autoClose: 5000 });
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTeacher((prevState) => ({
      ...prevState,
      [name]: name === "name" ? value.toUpperCase() : value,
    }));
  };

  const handleAddTeacher = () => {
    const { name, username } = newTeacher;
    if (!name || !username) {
      toast.error('All fields are required', { autoClose: 5000 });
      return;
    }

    var headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: localStorage.getItem('token'),
    };

    API.post('/portal/addTeacher', newTeacher, { headers })
      .then((response) => {
        if (response.data.response_code === 1000) {
          toast.success('Teacher added successfully', { autoClose: 5000 });
          toggleAddTeacherModal();
          fetchTeachers(); // Refresh the teacher list
        } else {
          toast.error(response.data.message, { autoClose: 5000 });
        }
      })
      .catch(() => {
        toast.error('Error adding teacher', { autoClose: 5000 });
      });
  };

  useEffect(() => {
    fetchTeachers();
  }, []);
  const availableTags = [
    { value: 'attendance_transfer', label: 'Attendance Transfer to MOEIS with phone' },
    { value: 'amalan_buruk_record', label:'Allow teacher to record masalah disiplin'},
    { value: 'allow_rmt_view', label:'Allow teacher to view RMT details'}
    // { value: 'exclude_amalan_baik', label: 'Exclude amalan baik transfer to MOEIS for these teachers' }
  ];

  const columns = [
    {
      name: 'Teacher Name',
      selector: (row) => row.full_name,
      sortable: true,
      minWidth: "280px",
      cell: (row) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.2",
          }}
        >
          <div style={{ fontWeight: "bold" }}>{row.full_name}</div>
          <div>
            {parseInt(row.session) === 0? (
              <Tag color="green" style={{ fontWeight: "bold", marginTop: "4px" }}>
                Morning Session
              </Tag>
            ) : (
              <Tag color="orange" style={{ fontWeight: "bold", marginTop: "4px" }}>
                Afternoon Session
              </Tag>
            )}
          </div>
        </div>
      ),
    },
    {
      name: 'Phone No',
      selector: (row) => row.phone_no,
      sortable: true,
      center: true,
    },

    {
      name: 'Role',
      selector: (row) => row.role == 1 ? 'Pengetua / PK HEM' : 'Teacher',
      sortable: true,
      center: true,
    },
    {
      name: "Tags",
      grow: 1,
      selector: (row) => row.tags || [],
      cell: (row) => {
        const tags = row.tags || [];
        const maxVisible = 3;
        const visible = tags.slice(0, maxVisible);
        const hidden = tags.slice(maxVisible);

        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {visible.map((tag, idx) => (
              <Tag key={idx} color="blue">{tag}</Tag>
            ))}
            {hidden.length > 0 && (
              <Dropdown
                overlay={
                  <Menu>
                    {hidden.map((tag, idx) => (
                      <Menu.Item key={idx}>{tag}</Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <Tag color="purple" style={{ cursor: "pointer" }}>
                  +{hidden.length} more
                </Tag>
              </Dropdown>
            )}
          </div>
        );
      }
    },
    {
      name: 'Action',
      cell: (row) => (
        <div>
          <Button
            color="info"
            className="mr-2"
            onClick={() => openEditTeacherModal(row)}
          >
            Edit
          </Button>
          <Button
            color="danger"
            onClick={() => openDeleteTeacherModal(row)}
          >
            Delete
          </Button>

        </div>
      ),
      center: true,
    },
  ];

  return (
    <Fragment>
      <ToastContainer theme="dark" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 xl-100">
            <div className="card">
              <div className="card-header">
                <Button
                  onClick={toggleAddTeacherModal}
                  color="primary"
                  className="ml-2"
                >
                  Add New Teacher
                </Button>
              </div>
              <div className="card-body">
                <div style={{ marginBottom: "1rem" }}>
                  <input
                    type="text"
                    placeholder="Search by name, phone, email, or tag..."
                    className="form-control"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </div>
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={filteredTeachers}
                    striped
                    center
                    persistTableHead
                    pagination
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Teacher Modal */}
      <Modal isOpen={modalAddTeacher} toggle={toggleAddTeacherModal}>
        <ModalHeader toggle={toggleAddTeacherModal}>Add New Teacher</ModalHeader>
        <ModalBody>
          <form>
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Enter Full Name"
                value={newTeacher.name}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="text"
                name="username"
                className="form-control"
                placeholder="Enter Phone Number"
                value={newTeacher.username}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Role</label>
              <select
                name="role"
                className="form-control"
                value={newTeacher.role || ""}
                onChange={handleInputChange}
                required
              >
                <option value="0">Teacher</option>
                <option value="1">Pengetua / PK HEM</option>
              </select>
            </div>
            <div className="form-group">
              <label>Session</label>
              <select
                name="session"
                className="form-control"
                value={newTeacher.session}
                onChange={handleInputChange}
                required
              >
                <option value="0">Morning</option>
                <option value="1">Afternoon</option>
              </select>
            </div>

          </form>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleAddTeacher}>
            Add Teacher
          </Button>
          <Button color="danger" onClick={toggleAddTeacherModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalEditTeacher} toggle={closeEditTeacherModal}>
        <ModalHeader toggle={closeEditTeacherModal}>Edit Teacher</ModalHeader>
        <ModalBody>
          <form>
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Enter Full Name"
                value={editTeacher.name}
                onChange={handleEditInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Role</label>
              <select
                name="role"
                className="form-control"
                value={editTeacher.role}
                onChange={handleEditInputChange}
                required
              >
                <option value="0">Teacher</option>
                <option value="1">Pengetua / PK HEM</option>
              </select>
            </div>
            <div className="form-group" style={{ marginTop: 16 }}>
              <label>Tags</label>
              <Select
                isMulti
                options={availableTags}
                value={(editTeacher.tags || []).map((t) => ({
                  value: t,
                  label: availableTags.find((opt) => opt.value === t)?.label || t,
                }))}
                onChange={(selected) =>
                  setEditTeacher({
                    ...editTeacher,
                    tags: selected.map((s) => s.value),
                  })
                }
                placeholder="Select tags"
              />
            </div>
            <div className="form-group">
              <label>Session</label>
              <select
                name="session"
                className="form-control"
                value={editTeacher.session}
                onChange={handleEditInputChange}
                required
              >
                <option value="0">Morning</option>
                <option value="1">Afternoon</option>
              </select>
            </div>

          </form>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleEditTeacher}>
            Save Changes
          </Button>
          <Button color="danger" onClick={closeEditTeacherModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalDeleteTeacher} toggle={closeDeleteTeacherModal}>
        <ModalHeader toggle={closeDeleteTeacherModal}>Confirm Delete</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this teacher? <br />
          <strong>{teacherToDelete?.full_name}</strong>
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            onClick={() => {
              handleDeleteTeacher(teacherToDelete?.username || teacherToDelete?.phone_no);
              closeDeleteTeacherModal();
            }}
          >
            Yes, Delete
          </Button>
          <Button color="secondary" onClick={closeDeleteTeacherModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

    </Fragment>
  );
};

export default TeacherPage;
